import { guid } from "@kaltura/mediaspace-shared-utils";
import { EmbedCodeTokens } from "../types";

/**
 * @see https://kaltura.github.io/kaltura-player-js/docs/embed-types.html
 */
export default class PlaylistEmbedV7 {
    static template =
        "<iframe"
        + ' src=\'{HOST}/p/{PARTNER_ID}/embedPlaykitJs/uiconf_id/{UICONF_ID}?iframeembed=true&playlist_id={PLAYLIST_ID}&config[provider]={"widgetId":"{WIDGET_ID}"}\''
        + " style='width: {WIDTH}px;height: {HEIGHT}px' allowfullscreen webkitallowfullscreen mozAllowFullScreen"
        + " allow='autoplay *; fullscreen *; encrypted-media *' {SANDBOX} frameborder='0' title='{TITLE}' ></iframe>";

    /**
     * generate dynamic embed
     */
    static playlistEmbedCodeV7(params: EmbedCodeTokens) {
        let out = PlaylistEmbedV7.template;
        let rg;
        out = out.replace("{ENTRY_ID}", params["ENTRY_ID"] ?? "");
        for (const [name, value] of Object.entries(params)) {
            rg = new RegExp("{" + name + "}", "g");
            out = out.replace(rg, value as string);
        }

        const uniqId = `kaltura_player_${guid()}`;
        out = out.replace(/player-placeholder/g, uniqId);
        const iframeSandboxAttr = params["OMIT_SANDBOX"]
            ? ""
            : 'sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"';
        out = out.replace("{SANDBOX}", iframeSandboxAttr);
        out = out.replace("{TITLE}", "Kaltura Player");
        return out;
    }
}
